import { getApiDomain } from '@/lib/curriculum-azure-functions'
import {
	FetchLearningSupportsParams,
	FetchLearningSupportsResponse,
} from '@/types/fetchLearningSupportFromAzure'
import { commonFetch } from '@/utils/fetchUtils'

export const fetchTeachingLearningSupport = async ({
	keywords,
	syllabus,
	keylearningareas = [],
	stages = [],
	years = [],
	page_size,
	page,
	codenames = [],
	resourcetypes = [],
	preview = false,
	sort_by = [],
}: FetchLearningSupportsParams & {
	preview: boolean
}) => {
	return await commonFetch<
		FetchLearningSupportsResponse,
		FetchLearningSupportsParams
	>(
		`${getApiDomain(preview)}${
			process.env.NEXT_PUBLIC_DCAPI_PATH_TEACHINGLEARNINGSUPPORT
		}`,
		{
			keywords,
			syllabus,
			keylearningareas,
			stages,
			years,
			page_size,
			page,
			codenames,
			resourcetypes,
			sort_by,
		},
	)
}
